import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, Phone, Mail, MapPin, Instagram } from 'lucide-react';
export function ContactPage() {
  return <main className="min-h-screen pt-32 pb-20 px-6" data-id="element-291">
      <div className="max-w-2xl mx-auto" data-id="element-292">
        {/* Hero Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="mb-16 text-center" data-id="element-293">
          <h1 className="text-5xl md:text-7xl font-heading text-white inline-block relative" data-id="element-294">
            LET'S WORK
            <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-1/2 h-1 bg-accent-blue" data-id="element-295"></div>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="space-y-8 flex flex-col" data-id="element-296">
          {/* WhatsApp CTA */}
          <a href="https://wa.me/48536052998" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-3 w-full bg-[#25D366] text-white font-heading tracking-wider text-2xl py-6 rounded-2xl hover:bg-[#20bd5a] transition-colors shadow-lg shadow-[#25D366]/20" data-id="element-297">
            <MessageCircle className="w-8 h-8" data-id="element-298" />
            CLICK TO WHATSAPP
          </a>

          {/* Contact Details */}
          <div className="bg-dark-elevated border border-dark-border rounded-2xl p-8 space-y-6" data-id="element-299">
            <div className="flex items-center gap-4 text-gray-300" data-id="element-300">
              <div className="w-12 h-12 rounded-full bg-dark-primary flex items-center justify-center border border-dark-border" data-id="element-301">
                <Phone className="w-5 h-5 text-accent-blue" data-id="element-302" />
              </div>
              <div data-id="element-303">
                <p className="text-sm text-gray-500 font-body" data-id="element-304">
                  Phone / WhatsApp
                </p>
                <p className="font-heading text-xl tracking-wide" data-id="element-305">
                  +48 536 052 998
                </p>
              </div>
            </div>

            <div className="flex items-center gap-4 text-gray-300" data-id="element-306">
              <div className="w-12 h-12 rounded-full bg-dark-primary flex items-center justify-center border border-dark-border" data-id="element-307">
                <Mail className="w-5 h-5 text-accent-blue" data-id="element-308" />
              </div>
              <div data-id="element-309">
                <p className="text-sm text-gray-500 font-body" data-id="element-310">Email</p>
                <p className="font-heading text-xl tracking-wide" data-id="element-311">
                  CONTACT@SZULCALEKS.COM
                </p>
              </div>
            </div>

            <a href="https://www.instagram.com/aleks.szulc1/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-4 text-gray-300 hover:text-white transition-colors" data-id="element-312">
              <div className="w-12 h-12 rounded-full bg-dark-primary flex items-center justify-center border border-dark-border" data-id="element-313">
                <Instagram className="w-5 h-5 text-accent-blue" data-id="element-314" />
              </div>
              <div data-id="element-315">
                <p className="text-sm text-gray-500 font-body" data-id="element-316">Instagram</p>
                <p className="font-heading text-xl tracking-wide" data-id="element-317">
                  @ALEKS.SZULC1
                </p>
              </div>
            </a>

            <div className="flex items-center gap-4 text-gray-300" data-id="element-318">
              <div className="w-12 h-12 rounded-full bg-dark-primary flex items-center justify-center border border-dark-border" data-id="element-319">
                <MapPin className="w-5 h-5 text-accent-blue" data-id="element-320" />
              </div>
              <div data-id="element-321">
                <p className="text-sm text-gray-500 font-body" data-id="element-322">Location</p>
                <p className="font-heading text-xl tracking-wide" data-id="element-323">
                  UL. KOŃSKI JAR 6, WARSZAWA
                </p>
              </div>
            </div>
          </div>

          {/* Map */}
          <div className="min-h-[250px] rounded-2xl overflow-hidden" data-id="element-324">
            <img src="https://cdn.magicpatterns.com/uploads/edwNNLnDKrMNdBaM9tfypV/image.png" alt="Google Map - ul. Koński Jar 6, 02-785 Warszawa" className="w-full h-full object-cover rounded-2xl" data-id="element-325" />
          </div>
        </motion.div>
      </div>
    </main>;
}